"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "Webkit": {
    "transform": true,
    "transformOrigin": true,
    "transformOriginX": true,
    "transformOriginY": true,
    "backfaceVisibility": true,
    "perspective": true,
    "perspectiveOrigin": true,
    "transformStyle": true,
    "transformOriginZ": true,
    "animation": true,
    "animationDelay": true,
    "animationDirection": true,
    "animationFillMode": true,
    "animationDuration": true,
    "animationIterationCount": true,
    "animationName": true,
    "animationPlayState": true,
    "animationTimingFunction": true,
    "appearance": true,
    "userSelect": true,
    "fontKerning": true,
    "textEmphasisPosition": true,
    "textEmphasis": true,
    "textEmphasisStyle": true,
    "textEmphasisColor": true,
    "boxDecorationBreak": true,
    "clipPath": true,
    "maskImage": true,
    "maskMode": true,
    "maskRepeat": true,
    "maskPosition": true,
    "maskClip": true,
    "maskOrigin": true,
    "maskSize": true,
    "maskComposite": true,
    "mask": true,
    "maskBorderSource": true,
    "maskBorderMode": true,
    "maskBorderSlice": true,
    "maskBorderWidth": true,
    "maskBorderOutset": true,
    "maskBorderRepeat": true,
    "maskBorder": true,
    "maskType": true,
    "textDecorationStyle": true,
    "textDecorationSkip": true,
    "textDecorationLine": true,
    "textDecorationColor": true,
    "filter": true,
    "fontFeatureSettings": true,
    "breakAfter": true,
    "breakBefore": true,
    "breakInside": true,
    "columnCount": true,
    "columnFill": true,
    "columnGap": true,
    "columnRule": true,
    "columnRuleColor": true,
    "columnRuleStyle": true,
    "columnRuleWidth": true,
    "columns": true,
    "columnSpan": true,
    "columnWidth": true,
    "flex": true,
    "flexBasis": true,
    "flexDirection": true,
    "flexGrow": true,
    "flexFlow": true,
    "flexShrink": true,
    "flexWrap": true,
    "alignContent": true,
    "alignItems": true,
    "alignSelf": true,
    "justifyContent": true,
    "order": true,
    "transition": true,
    "transitionDelay": true,
    "transitionDuration": true,
    "transitionProperty": true,
    "transitionTimingFunction": true,
    "backdropFilter": true,
    "scrollSnapType": true,
    "scrollSnapPointsX": true,
    "scrollSnapPointsY": true,
    "scrollSnapDestination": true,
    "scrollSnapCoordinate": true,
    "shapeImageThreshold": true,
    "shapeImageMargin": true,
    "shapeImageOutside": true,
    "hyphens": true,
    "flowInto": true,
    "flowFrom": true,
    "regionFragment": true,
    "textSizeAdjust": true
  },
  "Moz": {
    "appearance": true,
    "userSelect": true,
    "boxSizing": true,
    "textAlignLast": true,
    "textDecorationStyle": true,
    "textDecorationSkip": true,
    "textDecorationLine": true,
    "textDecorationColor": true,
    "tabSize": true,
    "hyphens": true,
    "fontFeatureSettings": true,
    "breakAfter": true,
    "breakBefore": true,
    "breakInside": true,
    "columnCount": true,
    "columnFill": true,
    "columnGap": true,
    "columnRule": true,
    "columnRuleColor": true,
    "columnRuleStyle": true,
    "columnRuleWidth": true,
    "columns": true,
    "columnSpan": true,
    "columnWidth": true
  },
  "ms": {
    "flex": true,
    "flexBasis": false,
    "flexDirection": true,
    "flexGrow": false,
    "flexFlow": true,
    "flexShrink": false,
    "flexWrap": true,
    "alignContent": false,
    "alignItems": false,
    "alignSelf": false,
    "justifyContent": false,
    "order": false,
    "transform": true,
    "transformOrigin": true,
    "transformOriginX": true,
    "transformOriginY": true,
    "userSelect": true,
    "wrapFlow": true,
    "wrapThrough": true,
    "wrapMargin": true,
    "scrollSnapType": true,
    "scrollSnapPointsX": true,
    "scrollSnapPointsY": true,
    "scrollSnapDestination": true,
    "scrollSnapCoordinate": true,
    "touchAction": true,
    "hyphens": true,
    "flowInto": true,
    "flowFrom": true,
    "breakBefore": true,
    "breakAfter": true,
    "breakInside": true,
    "regionFragment": true,
    "gridTemplateColumns": true,
    "gridTemplateRows": true,
    "gridTemplateAreas": true,
    "gridTemplate": true,
    "gridAutoColumns": true,
    "gridAutoRows": true,
    "gridAutoFlow": true,
    "grid": true,
    "gridRowStart": true,
    "gridColumnStart": true,
    "gridRowEnd": true,
    "gridRow": true,
    "gridColumn": true,
    "gridColumnEnd": true,
    "gridColumnGap": true,
    "gridRowGap": true,
    "gridArea": true,
    "gridGap": true,
    "textSizeAdjust": true
  }
};
module.exports = exports["default"];